/**
 * Atualiza o estado do input de celular com uma formatação adequada.
 *
 * Esta função é acionada por um evento onChange em um campo de celular.
 * Ela remove caracteres não numéricos e, se o número possuir 11 dígitos,
 * formata-o no padrão "(XX) XXXXX-XXXX". Se o valor tiver menos de 11 dígitos,
 * ele é exibido sem formatação. Caso o valor seja maior que 11 dígitos, é limitado a 11.
 *
 * @param {Event} event - Evento disparado pelo input.
 * @param {Function} setValueCel - Função para atualizar o estado do valor do celular.
 */
export function handleInputChangeCel(event, setValueCel) {
    let { value } = event.target;

    // Remove tudo que não for número
    value = value.replace(/\D/g, "");

    if (value.length > 11) {
        // Limita o número de caracteres a 11
        value = value.slice(0, 11);
    }

    if (value.length === 11) {
        // Formata o número de celular
        const formattedValue = value.replace(
            /(\d{2})(\d{5})(\d{4})/,
            "($1) $2-$3"
        );
        setValueCel(formattedValue);
    } else {
        // Caso contrário, exibe o valor sem formatação
        setValueCel(value);
    }
}